import api from '../token';

export const ListMoedaCambio = async (dados) => {
  try {
    const response = await api.post('/getMoedaCambio', dados);
    return response.data;
  } catch (error) {
     
    return { success: false, message: error.message };
  }
};



